const { primitives } = require('../../primitives')

const strokeIconVariables = {
  'icon-default': primitives['forest'][900],
  'icon-default-hover': primitives['forest'][1000],
  'icon-default-on-dark': primitives['neutral'][0],
  'icon-subtle': primitives['forest'][600],
  'icon-subtle-hover': primitives['forest'][700],
  'icon-disabled': primitives['neutral'][500],
}

module.exports = { strokeIconVariables }
